<template>
  <div class="locale-switcher">
    <!--
    <select :value="$i18n.locale" @change.prevent="changeLocale">
      <option :value="locale.code" v-for="locale in locales" :key="locale.code">{{locale.name}}</option>
    </select>
    -->

    <v-select
      :items="locales"
      item-text="name"
      item-value="code"
      return-object
      :placeholder="$t('language')"
      v-on:change="changeLocale"
    ></v-select>
  </div>
  
</template>

<script>
import { getSupportedLocales } from "@/util/i18n/supported-locales"

export default {
  data: () => ({
    locales: getSupportedLocales()
  }),
  computed: {
  },
  methods: {
    changeLocale(e) {
      window.location.href = '/' + e.code
    }
  }
}
</script>

<style>
.locale-switcher {
  margin-top: 13px;
  width: 200px;
}
@media only screen and (max-width: 600px) {
  .locale-switcher {
    width: 120px;
  }
}
</style>